import { useEffect, useState } from "react";
import { streamUrl } from "../../config";
import { FetchData } from "../../utils/FetchData";
import "./HeroVideo.scss";

const videoBackground = "poster_video.jpg";
const portaitVideo = "promo_generico_vertical.mp4";
const landscapeVideo = "horizontal_promo_web.mp4";

export function HeroVideo() {
  const [muted, setMuted] = useState<boolean>(true);
  const [token, setToken] = useState<string>();

  const fetchToken = () => {
    FetchData("token/stream")
      .then((data) => setToken(data.response.videoStreamToken))
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    fetchToken();
  }, []);

  const isPortrait = (): boolean => {
    return window.screen.availHeight > window.screen.availWidth;
  };

  const callStream = (fileName: string): string => {
    return token
      ? `${streamUrl}?filename=${fileName}&t=${encodeURI(token)}`
      : "";
  };

  return (
    <>
      {token && (
        <>
          <div
            className="hero-video"
            style={{
              backgroundImage: `url('${callStream(videoBackground)}`
            }}
          >
            <video
              id="heroVideo"
              autoPlay={true}
              muted={muted}
              playsInline={true}
            >
              <source
                src={callStream(isPortrait() ? portaitVideo : landscapeVideo)}
                type="video/mp4"
              />
            </video>
          </div>

          <div className="callToAction">
            {muted ? (
              <button
                onClick={() => setMuted(false)}
                className="round"
                id="unMuteIcon"
              >
                <i className="fas fa-volume-mute"></i>
              </button>
            ) : (
              <button
                onClick={() => setMuted(true)}
                className="round"
                id="muteIcon"
              >
                <i className="fas fa-volume-up"></i>
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}
